import { c as _c } from "react/compiler-runtime";
import useTranslation from '@/hooks/useTranslation';
import styled from 'styled-components';
export const ByTheNumbersPanel = t0 => {
  const $ = _c(11);
  const {
    items
  } = t0;
  const {
    t
  } = useTranslation("insights");
  let t1;
  if ($[0] !== t) {
    t1 = t("insights:InsightExecSumPage.byTheNumbers");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <caption className="cds-t-h5">{t1}</caption>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== items) {
    t3 = items.map(_temp);
    $[4] = items;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <tbody>{t3}</tbody>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <StyledTable>{t2}{t4}</StyledTable>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
interface IProps {
  items: INumbersItem[];
}
interface INumbersItem {
  heading: string;
  value: string;
}
const StyledTable = styled.table`
    width: 100%;
    border-top: 1px solid var(--color-lines-subtleDivider);

    caption {
        margin-bottom: var(--size-grid-half);
        text-align: start;
    }

    tr {
        border-bottom: 1px solid var(--color-lines-subtleDivider);
    }

    td,
    th {
        vertical-align: middle;
        padding: var(--size-grid-unit) 0;
    }

    th {
        color: var(--color-body-accent);
        text-align: left;
        padding-right: var(--size-grid-unit);
    }

    /* Undo table styles on smaller screens (easier than re-applying them all for larger screens) */
    @media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
        tbody,
        th,
        td,
        tr {
            display: block;
        }

        th {
            padding: var(--size-grid-unit) 0 0;
            height: auto;
        }

        td {
            padding: 0 0 var(--size-grid-unit) 0;
            height: auto;
        }
    }
`;
function _temp(item) {
  return <tr key={item.heading}><th className="cds-t-h2">{item.value}</th><td>{item.heading}</td></tr>;
}